import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { AdminMember, CommunityRole } from '@/types';

export type AdminDirectoryRoleTab = CommunityRole;

export function useAdminMembers(
  communityId: string,
  options: {
    search?: string;
    page?: number;
    limit?: number;
    role?: AdminDirectoryRoleTab;
  } = {}
) {
  const { search = '', page = 1, limit = 100, role = 'MEMBER' } = options;

  const { data, error, isLoading, mutate } = useSWR(
    communityId
      ? [`/api/communities/${communityId}/members/admin`, search, page, limit, role]
      : null,
    async ([url, search, page, limit, role]) => {
      const res = await axiosInstance.get(url, {
        params: { search, page, limit, role },
      });
      return res.data;
    }
  );

  return {
    members: (data?.members as AdminMember[]) || [],
    metadata: data?.metadata as {
      totalCount: number;
      totalPages: number;
      currentPage: number;
      limit: number;
      roleFilter?: AdminDirectoryRoleTab;
    },
    isLoading,
    error,
    mutate,
  };
}
